import React, { useContext, useEffect } from 'react';
import { Typography } from '@mui/material';
import Sidebar from '../uiParts/SideBar';
import StaffEditCard from '../uiParts/StaffEditCard';
import { AuthContext } from '../../contexts/auth';
import { useNavigate } from 'react-router-dom';
import MetaTitle from '../utils/MetaTitle';

const styles = {
  mypageWrapper: {
    '@media screen and (max-width:960px)': {
      flexDirection: 'column',
    },
    display: 'flex',
    width: '100%',
  },
  sidebar: {
    '@media screen and (max-width:960px)': {
      minWidth: '240px',
      width: '240px',
    },
    top: 0,
    left: 0,
  },
  contentArea: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    minHeight: '100vh',
    '@media screen and (max-width:960px)': {
      minHeight: 'calc(100vh - 48px)',
    },
  },
  card: {
    '@media screen and (max-width:960px)': {
      padding: '24px 16px 80px 16px',
    },
    width: '100%',
    maxWidth: '600px',
  },
};

const StaffEdit = (): React.ReactElement => {
  const { user, isLoading } = useContext(AuthContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (isLoading) return;
    // 未ログイン状態の場合はログイン画面へ遷移
    if (user === null) navigate('/');
  }, [user, isLoading]);

  return (
    <>
      <MetaTitle />
      <Typography component="div" sx={styles.mypageWrapper}>
        <Typography component="div" sx={styles.sidebar}>
          <Sidebar />
        </Typography>
        <Typography component="div" sx={styles.contentArea}>
          <Typography component="div" sx={styles.card}>
            <StaffEditCard />
          </Typography>
        </Typography>
      </Typography>
    </>
  );
};
export default StaffEdit;
